export default {
  allMaintenanceTypes: [],
}
